/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import { modelsById } from '#selectors/entities/models.js';
import AdvisoryBanner from './AdvisoryBanner.jsx';

const mapStateToProps = (state, ownProps) => {
  const { modelId } = ownProps;
  const model = modelsById(state)[modelId];
  return {
    advisories: model ? model.advisories : null,
  };
};

export default connect(mapStateToProps)(AdvisoryBanner);
